import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles((theme) => ({
  counterStyle: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "black",
  },
}));

const IAMDATAllotment = (props) => {
  const classes = useStyles();

  return (
    <>
      {props.dayState.date && (
        <div data-testid="iam-dat-allotment">
          <Grid
            container
            justifyContent={"flex-end"}
            sx={{ paddingRight: "5px", fontWeight: "normal", fontSize: "16px", color: "primary.swaBlue" }}
          >
            {props.dayState.date.slice(-2)}
          </Grid>
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-around",
              fontSize: "10px",
              fontWeight: "bold",
              color: "primary.swaBlue",
              textAlign: "center",
              padding: "10px",
            }}
          >
            <Grid item md={12} sx={{ marginTop: "20px" }}>
              AM OR PM
            </Grid>
            <Typography component="span" className={classes.counterStyle} style={{ fontSize: "18px" }}>
              {props.dayState.amOrPmCount}
            </Typography>
          </Grid>
        </div>
      )}
    </>
  );
};

IAMDATAllotment.propTypes = {
  dayState: PropTypes.object.isRequired,
};

export default IAMDATAllotment;
